import { createAction } from '@reduxjs/toolkit';

export const acceptOffer = createAction('offer/acceptOffer');
export const rejectOffer = createAction('offer/rejectOffer');
